export namespace IPayoutTermEnum {
  export type PayoutTermType =
    | 'UNSPECIFIED'
    | 'CREDIT_CARD'
    | 'ACH_NEXT_DAY'
    | 'ACH_NET30'
    | 'ACH_NEXT_DAY_WITH_UPFRONT'
    | 'ACH_NET30_WITH_UPFRONT'
    | 'ACH_NET60';

  export enum PayoutTerm {
    UNSPECIFIED = 'UNSPECIFIED',
    CREDIT_CARD = 'CREDIT_CARD',
    ACH_NEXT_DAY = 'ACH_NEXT_DAY',
    ACH_NET30 = 'ACH_NET30',
    /**
     * Applied to brand orders that are eligible for upfront payments on brands that currently have ACH_NEXT_DAY
     * as their payout term. Shouldn't be set as the default on brands
     */
    ACH_NEXT_DAY_WITH_UPFRONT = 'ACH_NEXT_DAY_WITH_UPFRONT',
    /**
     * Applied to brand orders that are eligible for upfront payments on brands that currently have ACH_NET30
     * as their payout term. Shouldn't be set as the default on brands
     */
    ACH_NET30_WITH_UPFRONT = 'ACH_NET30_WITH_UPFRONT',
    ACH_NET60 = 'ACH_NET60',
  }

  /**
   * Return an instance of IPayoutTermEnum with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IPayoutTermEnum>): IPayoutTermEnum =>
    ({
      ...(partial ?? {}),
    } as IPayoutTermEnum);
}

export interface IPayoutTermEnum {}
